import React, { Component } from "react";
import "../style/TagDropdown.css";

// COMPONENTS
import CaretDown from "../icons/CaretDown";
import CaretUp from "../icons/CaretUp";

class TagDropdown extends Component {
  constructor(props) {
    super(props);
    // this.props.items.filter;
    this.state = {
      expand: false
    };
  }
  render() {
    console.log(this.props);
    if (this.state.expand) {
      return (
        <div className="TagDropdown">
          <div className="dropdown-menu">
            {this.props.items.map(dropdownItem => {
              return (
                <label className="checkbox-label--dropdown" key={dropdownItem}>
                  <input
                    onChange={this.props.onChange}
                    type="checkbox"
                    name={dropdownItem}
                    className="checkbox checkbox--dropdown-item"
                  />
                  {dropdownItem}
                </label>
              );
            })}
            <button
              onClick={() => {
                this.setState(prevState => {
                  return {
                    expand: !prevState.expand
                  };
                });
              }}
              className="collapse-btn"
            >
              <CaretUp />
            </button>
          </div>
        </div>
      );
    } else {
      return (
        <div
          onClick={() => {
            this.setState(prevState => {
              return {
                expand: !prevState.expand
              };
            });
          }}
          className="TagDropdown"
        >
          <p>
            {this.props.items[0]}{" "}
            <span className="expand-btn">
              <CaretDown />
            </span>
          </p>
        </div>
      );
    }
  }
}

export default TagDropdown;



// WEBPACK FOOTER //
// ./src/components/TagDropdown.js